const convertToJsonType = (value: string): string => {
  switch (value) {
    case 'UInt':
    case 'Int':
      return 'JInteger';
      break;
    case 'Char':
      return 'JText';
      break;
    case 'Byte':
      return 'JBinary';
      break;
    case 'Array':
      return 'JSequence';
      break;
    default:
      return 'UnknownType';
  }
};

export const convertInputToJsonFormat = ({
  unparseString,
  inputValue,
}: {
  unparseString: string;
  inputValue: string | string[];
}) => {
  if (!unparseString) {
    return '';
  }

  const parsedString = unparseString.split(' - ');
  const parsedName = parsedString[0];
  const parsedType = parsedString[1];
  const parseIsArray = parsedType.match(/([\w]+)\[(\d)\]/);
  const parseNonArray = parsedType.match(/([A-Za-z]+)\(?([\d]+)\)?/);

  if (parseIsArray) {
    const size: number = +parseIsArray[2];
    const JValue = convertToJsonType('Array');
    const JType = parseIsArray[1]
      ? (parseIsArray[1]?.match(/([A-Za-z]+)/)?.[0] ?? '')
      : '';
    if (Array.isArray(inputValue)) {
      const clusterValue = (inputValue as string[]).reduce(
        (accumulator, current) => {
          accumulator.push({
            [convertToJsonType(JType)]: {
              type: 'J' + parseIsArray[1],
              v: +current,
            },
          });
          return accumulator;
        },
        [] as any[],
      );
      const entry = {
        name: parsedName,
        value: {
          [JValue]: {
            type: 'J' + parseIsArray[1],
            size: size,
            v: clusterValue,
          },
        },
      };

      return entry;
    }
  } else if (parseNonArray) {
    const JType = parseNonArray[1];
    const JValue = convertToJsonType(parseNonArray[1]);
    if (JValue === 'JInteger') {
      const entry = {
        name: parsedName,
        value: {
          [JValue as string]: {
            type: ('J' + parseNonArray[0]) as string,
            v: +inputValue,
          },
        },
      };
      return entry;
    } else {
      const entry = {
        name: parsedName,
        value: {
          [JValue as string]: {
            type: { ['J' + JType]: { size: +parseNonArray[2] } },

            v: inputValue as string,
          },
        },
      };
      return entry;
    }
  } else {
    return '';
  }
};
